import { Reducer } from 'redux';

import {
  DownloadCommunityInsightsLoadFulfilledAction,
  DownloadCommunityInsightsLoadPendingAction,
  DownloadCommunityInsightsLoadRejectedAction,
} from '../../domains/downloadCommunityInsights/actions.types';
import { moveToFulfilled, moveToPending, moveToRejected } from '../types';

import { DownloadCommunityInsightsEntities } from './types';

export type DownloadCommunityInsightsLoadAction =
  | DownloadCommunityInsightsLoadPendingAction
  | DownloadCommunityInsightsLoadFulfilledAction
  | DownloadCommunityInsightsLoadRejectedAction;

const initialState: DownloadCommunityInsightsEntities = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<DownloadCommunityInsightsEntities, DownloadCommunityInsightsLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'DOWNLOAD_COMMUNITY_INSIGHTS.LOAD_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'DOWNLOAD_COMMUNITY_INSIGHTS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    case 'DOWNLOAD_COMMUNITY_INSIGHTS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.communityInsightsDownload);
    default:
      return state;
  }
};

export default reducer;
